<template>
  <footer class="w-full bg-cdp-grey-100 py-2 shadow-inner">
    <div class="flex justify-between text-sm text-cdp-black-300">
      <div class="ml-auto">
        ©
        <a
          href="https://www.stockfeel.com.tw"
          target="_blank"
          rel="noopener"
          class="hover:underline"
          >FeelGroup</a
        >. All Rights Reserved.

        {{ version }}
        <a class="items-center">
          <icon name="support-vs" class="mx-1 inline-block h-4 w-4" />
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import { useI18n } from 'vue-i18n';
export default {
  name: 'CDPFooter',
  setup() {
    const { t } = useI18n();
    return {
      t,
      // eslint-disable-next-line no-undef
      version: import.meta.env.VITE_GIT_LATEST_TAG
    };
  }
};
</script>